import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toggleAddParticipants } from 'focus_groups/ducks/view_state';
import Share from 'focus_groups/components/share';

const mapStateToProps = (state, { params }) => {
  const group = idx(state, _ => _.project.focusGroups.viewState.currentGroup) || {};
  const { subcategory, pageSlug } = params;
  const participantsUrl = (
    `/${subcategory}/${pageSlug}/focus-groups/${group.id}/view/participants/`
  );

  const link = (
    `${window.location.origin}/focus-group-participate/${group.id}/${group.anonymous_key}/?utm_source=focusgroups_app&utm_medium=web&utm_campaign=focusgroups`
  );

  return {
    link,
    participantsUrl
  };
}

export default withRouter(connect(mapStateToProps, { toggleAddParticipants })(Share));



// WEBPACK FOOTER //
// ./focus_groups/containers/share.js